module.exports = __webpack_public_path__ + "static/img/no.ca7f6d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/weekly/no.png
// module id = N9Vh
// module chunks = 0